import { ChangeDetectionStrategy, Component } from '@angular/core'

@Component({
  selector: 'terms',
  imports: [],
  templateUrl: './terms.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Terms {}
